$(document).ready(function () {
    if (!window.NOTE_EMBEDS) {
        window.NOTE_EMBEDS = true;
        window.NOTE_DEBUG = [];

        function hasClass(element, className) {
            return element.className.match(new RegExp('(\\s|^)' + className + '(\\s|$)'));
        }

        function addClass(element, className) {
            if (!this.hasClass(element, className)) element.className += " " + className;
        }

        function removeClass(element, className) {
            if (hasClass(element, className)) {
                var regex = new RegExp('(\\s|^)' + className + '(\\s|$)');
                element.className = element.className.replace(regex, ' ');
            }
        }

        var eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
        var listenForEvent = window[eventMethod];
        var eventName = eventMethod == 'attachEvent' ? 'onmessage' : 'message';

        listenForEvent(eventName, function (event) {
            var datastr = event.data + "";
            var e = datastr.split('::');
            window.NOTE_DEBUG.push(event.data);
            if (e[0] == 'height') {
                var embeds = document.querySelectorAll('iframe[src="' + e[1] + '"]');
                for (var i = 0; i < embeds.length; i++) {
                    newHeight = parseInt(e[2]);
                    if (embeds[i].style.removeProperty) {
                        embeds[i].style.removeProperty('height');
                    } else {
                        embeds[i].style.removeAttribute('height');
                    }
                    embeds[i].height = newHeight * 1;
                    embeds[i].setAttribute('data-ready', true);
                }
            }
        });
    }
});
